import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteCenterGroup(centerId: number, groupId: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.deleteCenterGroup.url, { id: centerId, groupId }))
    .delete()
}
